export const isPasswordValid = (value) => {
  let reg = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,16})"
  );

  if (reg.test(value)) {
    return true;
  } else return false;
};
